<template>
    <div
        v-resize:throttle.10="onResize"
        class="slider"
    >
        <div
            class="area"
            @mousedown="startSlide"
            @mousemove="moveSlide"
            @mouseup="stopSlide"
            @mouseout="stopSlide"
        >
            <div class="line" />
            <div
                :style="{left: x - 5 + 'px'}"
                class="bar"
            />
        </div>
    </div>
</template>

<script>
import resize from 'vue-resize-directive';

export default {
    name: 'Slider',
    directives: {
        resize
    },
    props: {
        im: {
            required: true,
            validator(value) {
                return typeof value === 'boolean' || typeof value === 'function';
            }
        },
        edit: {
            required: true,
            validator(value) {
                return typeof value === 'boolean' || typeof value === 'object';
            }
        }
    },
    data() {
        return {
            drawing: false,
            x: 0,
            width: 0
        };
    },
    mounted() {
        this.onResize();
    },
    methods: {
        onResize() {
            this.width = this.$el.clientWidth - 20;
            const perc = 50 + this.edit.slider / 0.5;
            this.x = (perc * this.width) / 100;
        },
        startSlide(e) {
            this.drawing = true;
            this.setX(e.offsetX);
        },
        moveSlide(e) {
            if (this.drawing) {
                this.setX(e.offsetX);
            }
        },
        stopSlide() {
            this.drawing = false;
        },
        setX(x) {
            this.x = x;

            const perc = (100 * x) / this.width;

            // this is a range from -25 to 25
            this.edit.slider = 0.5 * (perc - 50);
        }
    }
};
</script>

<style lang="scss" scoped>
.slider {
    height: 100%;
    flex: 1;
    background-color: #444444;
    position: relative;
}

.area {
    cursor: pointer;
    position: absolute;
    width: calc(100% - 20px);
    left: 10px;
    top: 10%;
    height: 80%;
    display: flex;
    align-items: center;
}

.line {
    width: 100%;
    height: 1px;
    pointer-events: none;
    background-color: #666666;

    &::after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        height: 100%;
        background-color: #666666;
        width: 1px;
    }
}

.bar {
    position: absolute;
    pointer-events: none;
    height: 20px;
    width: 10px;
    background-color: #888888;
    top: 2px;
    box-shadow: 2px 2px 6px #222222;
    cursor: pointer;
}
</style>
